import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAPIURL } from "helpers";
import { getBaseQueryWithRejection } from "redux/helper.redux";

const baseQueryWithRejection = getBaseQueryWithRejection(
  fetchBaseQuery({
    baseUrl: getAPIURL("/api/pvsa/movement"),
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.accessToken;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  })
);


export const movementApi = createApi({
  reducerPath: "movementApi",
  baseQuery: baseQueryWithRejection,
  tagTypes: ["MissionMovement"],
  endpoints: (builder) => ({
    getMovement: builder.query({
      query: (params) => {
        const tmp = new URLSearchParams();
        if (params.missionID) tmp.append("mission_id", params.missionID);
        if (params.userId) tmp.append("user_id", params.userId);
        if (params.formStatus) tmp.append("form_status", params.formStatus);
        return `?${tmp.toString()}`;
      },
      transformResponse: (response) => response.data,
      providesTags: ["MissionMovement"],
    }),
    getBaselineDocuments: builder.query({
        query: (params) => {
            const tmp = new URLSearchParams();
            if (params.missionId) tmp.append("mission_id", params.missionId);
            if (params.userId) tmp.append("user_id", params.userId);
            return `/baseline-documents/?${tmp.toString()}`;
        },
        transformResponse: (response) => response.data,
        providesTags: ["MissionMovement"],
    }),
    getLatestMovementForTemplate: builder.query({
      query: ({missionId, templateId}) => `/latest-movement-for-template?template_id=${templateId}&mission_id=${missionId}`,
    //   transformResponse: (response) => response.data,
      providesTags: [],
    }),
    getReopenForm: builder.query({
      query: ({movementId}) => {
        return `reopen-form/${movementId}`;
      },
      transformResponse: (response) => response.data,
      providesTags: ["MissionMovement"],
    }),
    updateMovementStatus: builder.mutation({
        query: ({ movementId, status }) => ({
            url: `/update-status/${movementId}`,
            method: "PUT",
            body: {
                status
            },
            transformResponse: (response) => response.data,
        }),
    }),
    getPastMovementsOfSameTemplateAndMission: builder.query({
      query: ({ movementId, templateId}) => {

        return `past-movement-of-same-template-and-mission?movement-id=${movementId}&template-id=${templateId}`;
      },
      transformResponse: (response) => response.data,
      providesTags: ["MissionMovement"],
    }),
  }),
});

export const { 
    useGetMovementQuery, 
    useLazyGetMovementQuery, 
    useGetBaselineDocumentsQuery,
    useGetLatestMovementForTemplateQuery,
    useLazyGetLatestMovementForTemplateQuery,
    useLazyGetReopenFormQuery,
    useUpdateMovementStatusMutation,
    useGetPastMovementsOfSameTemplateAndMissionQuery,
    useLazyGetPastMovementsOfSameTemplateAndMissionQuery,
} = movementApi;
